import {Link} from "react-router-dom";
import {useBuyer} from "../store/BuyerContext";
export default function ExportPrice({product}){
 const {buyer,prices,loading,priceError}=useBuyer();
 if(loading)return null;
 if(!buyer)return <Link to="/buyer-access" className="inline-flex items-center min-h-11 text-xs underline underline-offset-4 mt-2">Sign in / request access to view USD prices</Link>;
 const price=prices.find(p=>p.product_id===(product.id||product.slug));
 return <div className="mt-4 text-sm" aria-live="polite">{price?<><strong>USD {(price.usd_cents/100).toFixed(2)} / {price.unit}</strong><p className="text-xs text-mocha mt-1">{price.basis} · MOQ 500 pieces</p></>:<p className="text-mocha">{priceError?"Prices could not load. Please refresh or contact our team.":"USD price on enquiry"}</p>}</div>;
}
